import React, { useState } from "react";
import { formatNPR } from '../../utils/currency';
import Modal from "../modal/Modal";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";


function Card({ data }) {
  let [isOpen, setIsOpen] = useState(false);
  const cart = useSelector((state) => state.cart);
  const navigate = useNavigate();
  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  const Cart = cart.cartItems.find((cartItem) => cartItem.id === data.id);

  const handleclick = () => {
    navigate(`/product/${data?.slug}`)
  }
  return (
    <>
      {" "}
      <div  className="group box-border overflow-hidden cursor-pointer flex rounded-md shadow-sm pr-0 flex-col items-center bg-white relative">
        <div

          className="relative flex justify-center w-full h-60 bg-gray-50"
        >
          {/* {data.discount === 0 ? (
            ""
          ) : (
            <span className="absolute text-dark text-xs bg-orange-500 text-white py-1 px-2 rounded font-medium z-10 right-4 top-4">
              {Math.ceil(data.discount)}% Off
            </span>
          )} */}
          {/* {data.quantity !== 0 ? (
            ""
          ) : (
            <span className="absolute inline-flex items-center justify-center px-2 py-1 bg-red-100 text-red-600 border-0 rounded-full text-xs font-semibold z-10 left-4 top-4">
              Stock Out
            </span>
          )} */}

          <div className="absolute top-4 right-4 opacity-0 z-10 group-hover:opacity-100 transition-opacity duration-300">
            <button
              onClick={openModal}
              className="p-2 bg-black bg-opacity-50  rounded-full hover:bg-opacity-70 transition-all"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z"
                />
              </svg>
            </button>
          </div>


          <span
            style={{
              boxSizing: "borderBox",
              display: "inline-block",
              overflow: "hidden",
              width: "100%",
              height: "initial",
              background: "none",
              opacity: "1",
              border: "0px",
              margin: "0px",
              padding: "0px",
              position: "relative",
              maxWidth: "100%",
            }}
          >
            <span
              style={{
                boxSizing: "border-box",
                display: "block",
                width: "initial",
                height: "initial",
                background: "none",
                opacity: "1",
                border: "0",
                margin: "0",
                padding: "0",
                maxWidth: "100%",
              }}
            >
            </span>
            <img
              src={data?.thumbnail_image}
              alt={data?.name}
              onClick={handleclick}
              decoding="async"
              data-nimg="intrinsic"
              className="object-cover transition duration-150 ease-linear transform z-10 scale-105 group-hover:scale-100"
              style={{
                inset: "0px",
                boxSizing: "border-box",
                padding: "0px",
                border: "none",
                margin: "auto",
                display: " block",
                width: "160px",
                height: "160px",
                minWidth: "100%",
                maxWidth: "100%",
                minHeight: "100%",
                maxHeight: " 100%",
              }}
            />
          </span>
        </div>
        <div className="w-full px-3 lg:px-4 pb-4 overflow-hidden">
          <div className="relative mb-1 mt-4">

            <h2 onClick={handleclick} className="text-heading truncate mb-0 block text-sm font-medium text-gray-600 hover:text-gray-800 transition-all">
              <span className="line-clamp-2 capitalize">
                {data?.name}
              </span>
            </h2>
            <span className="text-gray-400 font-semibold text-xs d-block mb-1">
              {data?.category_details?.name}
            </span>
          </div>
          <div className="flex justify-between items-center text-heading text-sm sm:text-base space-s-2 md:text-base lg:text-xl mt-2">
            <div className="product font-bold">
              <span className="inline-block text-[0.8em] text-brand-600">
                {formatNPR(data?.properties?.price_range?.lowest_price ?? data?.properties?.price_range?.highest_price)}

              </span>
              {/* {data.price === data.originalPrice ? (
                ""
              ) : (
                <del className="sm:text-sm font-normal text-base text-gray-400 ml-1">
                  ${data.originalPrice}
                </del>
              )} */}
            </div>

            {Cart ? (
              <div>
                {/* <div className="h-9 w-auto flex flex-wrap items-center justify-evenly py-1 px-2 bg-brand-600 text-white rounded"> */}
                {/* <button onClick={() => dispatch(decreaseCart(data))}>
                    <span className="text-dark text-base">
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth="0"
                        viewBox="0 0 512 512"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="32"
                          d="M400 256H112"
                        ></path>
                      </svg>
                    </span>
                  </button> */}
                {/* <p className="text-sm text-dark px-1 font-semibold"> */}
                {/* {Cart.cartQuantity} */}
                {/* </p> */}
                {/* <button onClick={() => dispatch(incrementCart(data))}>
                    <span className="text-dark text-base">
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth="0"
                        viewBox="0 0 512 512"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="32"
                          d="M256 112v288m144-144H112"
                        ></path>
                      </svg>
                    </span>
                  </button> */}
                {/* </div> */}
              </div>
            ) : (
              <button
                // disabled={data.quantity === 0 ? true : false}
                // onClick={() => handleAddToCart(data)}
                ariallabel="chart"
              // className={data.quantity === 0 ? "!cursor-default h-9 w-9 flex items-center justify-center border border-gray-200 rounded text-brand-500 hover:border-brand-500 hover:bg-brand-600 hover:text-white transition-all" : "!cursor-pointer h-9 w-9 flex items-center justify-center border border-gray-200 rounded text-brand-500 hover:border-brand-500 hover:bg-brand-600 hover:text-white transition-all"}
              >
                <button onClick={handleclick} className="text-xs bg-brand-600 text-white px-2 py-1 rounded-md hover:bg-brand-700 border border-transparent transition-all duration-300">
                  View Details
                  {/* <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
                    />
                  </svg> */}
                </button>
              </button>
            )}
          </div>
        </div>
      </div>
      {isOpen && <Modal slug={data?.slug} isOpen={isOpen} closeModal={closeModal} />}
    </>
  );
}

export default Card;
